/**
 * @file Handles request polling
 * */
import { fetchJson, HTTPMethod } from '@padlet/fetch'
import getCsrfToken from 'bits/csrf_token'

interface PollingOptions {
  intervalSecs: number
  maxAttempts: number
}

interface PollingArguments {
  pollingUrl: string
  validationCallback?: (response) => boolean
  options: PollingOptions
}

const defaultValidationCallback = (response): boolean => response.done

const poll = async ({ pollingUrl, validationCallback, options }: PollingArguments): Promise<any> => {
  let attempts = 0
  const executePoll = async (resolve, reject): Promise<void> => {
    const response = await fetchJson(pollingUrl, {
      method: HTTPMethod.post,
      csrfToken: getCsrfToken(),
    })
    attempts++
    if (validationCallback ? validationCallback(response) : defaultValidationCallback(response)) {
      return resolve(response)
    } else if (attempts >= options.maxAttempts) {
      return reject()
    } else {
      setTimeout(executePoll, options.intervalSecs * 1000, resolve, reject)
    }
  }
  return new Promise(executePoll)
}

export { poll }
